import { createApiAction } from 'src/api';

export const ADD_DBA_START = 'account/add_dba_start';
export const ADD_DBA_SUCCESS = 'account/add_dba_success';
export const ADD_DBA_FAILURE = 'account/add_dba_failure';

export const UPDATE_DBA_START = 'account/update_dba_start';
export const UPDATE_DBA_SUCCESS = 'account/update_dba_success';
export const UPDATE_DBA_FAILURE = 'account/update_dba_failure';

export const DELETE_DBA_START = 'account/delete_dba_start';
export const DELETE_DBA_SUCCESS = 'account/delete_dba_success';
export const DELETE_DBA_FAILURE = 'account/delete_dba_failure';

export const addAccountDBA = ({ accountId, name }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/dbas/`,
      method: 'POST',
      body: {
        dba_name: name,
      },
    },
    [ADD_DBA_START, ADD_DBA_SUCCESS, ADD_DBA_FAILURE]
  );

export const updateAccountDBA = ({ accountId, dbaId, name }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/dbas/${dbaId}/`,
      method: 'PUT',
      body: {
        dba_name: name,
      },
    },
    [UPDATE_DBA_START, UPDATE_DBA_SUCCESS, UPDATE_DBA_FAILURE]
  );

export const deleteAccountDBA = ({ accountId, dbaId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/dbas/${dbaId}/`,
      method: 'DELETE',
    },
    [DELETE_DBA_START, DELETE_DBA_SUCCESS, DELETE_DBA_FAILURE]
  );
};
